import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSignal = new Subject<{ isLoading: boolean; loaderMessage: string | null }>();
  loaderSignal$ = this.loaderSignal.asObservable();

  constructor() {}

  loaderOn(loaderMessage: string | null = null) {
    this.loaderSignal.next({ isLoading: true, loaderMessage: loaderMessage });
  }
  loaderOff = () => this.loaderSignal.next({ isLoading: false, loaderMessage: null });
}
